import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchTopupsNeedingAttention, retryTopup } from "@/api/topups";

/**
 * The funding-attention strip.
 *
 * Polled rather than pushed: a campaign's card can start failing at any moment on a cron nobody is
 * watching, and a page left open on someone's second monitor is exactly where this needs to appear.
 */
export function useTopupsNeedingAttention() {
  return useQuery({
    queryKey: ["topups", "attention"],
    queryFn: fetchTopupsNeedingAttention,
    refetchInterval: 60_000,
  });
}

export function useRetryTopup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (campaignId: number) => retryTopup(campaignId),
    // A retry that succeeds takes the row off the strip, and one that declines again changes what
    // the row says — so the list is refetched either way.
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["topups", "attention"] }),
  });
}
